<template>
  <span id="edit-user">
    <v-btn icon color="black" class="button-edit" @click="dialogEdit = true">
        <img src="/images/icons/edit_user.svg" alt="edit-user" style="vertical-align: middle; max-width: 26px;"/>
    </v-btn>
    <v-dialog v-model="dialogEdit" max-width="500">
      <v-card>
        <v-card-title class="tw-mt-4">
          <div class="tw-font-bold tw-text-xl">แก้ไขสิทธิผู้ใช้งาน</div>
        </v-card-title>
        <v-card-text class="tw-pb-0">
          <v-row>
            <v-col>
              <v-text-field v-model="email" label="อีเมล" class="input-style" outlined disabled></v-text-field>
            </v-col>
          </v-row>
          <v-radio-group v-if="userAuth?.isEngineer" v-model="role" row :disabled="loading" class="tw-mt-0">
            <v-radio label="SLD Admin" color="#6ec39b" value="developer"></v-radio>
            <v-radio :label="product?.isPdfDoc ? 'IT Admin' : 'Owner'" color="#6ec39b" value="owner"></v-radio>
            <v-radio label="User" color="#6ec39b" value="user"></v-radio>
          </v-radio-group>
          <v-radio-group v-else v-model="role" row :disabled="loading" class="tw-mt-0">
            <v-radio :label="product?.isPdfDoc ? 'IT Admin' : 'Owner'" color="#6ec39b" value="owner"></v-radio>
            <v-radio label="User" color="#6ec39b" value="user"></v-radio>
          </v-radio-group>
          <!-- v check more role  -->
           <!-- <v-checkbox v-if="userAuth?.isEngineer && role === 'owner'" v-model="isDeveloper" label="SLD Admin" color="#6ec39b" class="tw-mt-0"></v-checkbox> -->
        </v-card-text>
        <save-alert :status="updateStatus"
                    error-text="แก้ไขข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
                    success-text="แก้ไขข้อมูลสำเร็จ" v-if="updateStatus"></save-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn color="black darken-1" text @click="dialogEdit = false" :disabled="loading"
                  class="tw-tracking-normal tw-text-lg">
          <v-icon left class="tw-text-2xl">mdi-close-circle-outline</v-icon>
          ยกเลิก
        </v-btn>
          <v-btn color="green darken-1" text @click="addUser" v-if="userData && role" :disabled="loading" class="tw-tracking-normal tw-text-lg">
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="green"
              style="margin-right: 10px;"
            ></v-progress-circular>
            <v-icon left class="tw-text-2xl">mdi-content-save-outline</v-icon> บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import {mapState} from "vuex";
import SaveAlert from "../save-alert"
import getRole from "@/libs/getRole";


export default {
  name: 'AddUser',
  props:{
    user: Object,
    userAuth: Object,
    product: Object,
  },
  components:{
    SaveAlert
  },
  data() {
    return {
      email: "",
      dialogEdit: false,
      role: "",
      isDeveloper: false,
    }
  },
  computed: mapState({
    userData: state => state.user.userData,
    loading: state => state.user.loading,
    updateStatus: state => state.user.updateDataStatus
  }),
  methods: {
    setValueDialog: function(){
      this.email = this.user.user.email
      this.role = this.checkRole(this.user)
      this.isDeveloper = this.user.isDeveloper
    },
    addUser: function () {
      this.$store.dispatch('user/updateRoleUser', {user: this.user, role: this.role, isDeveloper: this.isDeveloper})
    },
    checkRole: function (user){
       return getRole(user)
    }
  },
  watch:{
    dialogEdit:{
      handler: function (){
        if(!this.dialogEdit){
          this.$store.dispatch('user/setUpdateDataStatusEmpty')
        }else {
          this.setValueDialog();
        }
      }
    }
  }
}
</script>

<style lang="scss">
#edit-user {
  .input-style.v-input .v-input__slot {
    border-radius: 10px;
  }

  .v-text-field__details {
    display: none !important;
  }

  .button-edit {
    margin-right: 6px;
  }
}
</style>
